import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'HealthPathCore',
    shortName: 'HealthPathCore',
    description:
        'Clear, evidence-informed health guidance across mental health, physical health, and nutrition. Sourced from published research and written for real life.',
    url: 'https://healthpathcore.com',
    // Corrections inbox published on /methodology. This must be a mailbox that
    // actually receives mail: a corrections route that bounces is worse than none.
    email: 'corrections@healthpathcore.com',
    locale: 'en_US',
    ogImage: '/og.png',
    ogImageAlt: 'HealthPathCore: evidence-informed health knowledge',
    ogImageWidth: 1344,
    ogImageHeight: 768
}
